import { categories } from '@/mocks/categories';
import { Link } from 'react-router-dom';

export default function CategorySection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-sm font-medium rounded-full mb-4">
            <i className="ri-grid-line mr-1"></i>
            内容分类
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            海量内容，随心选择
          </h2>
          <p className="text-foreground-500 text-base max-w-2xl mx-auto">
            10+个内容分类，覆盖电影、电视剧、综艺、动漫、纪录片等全品类
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat, index) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-5 text-center hover:bg-background-200/50 transition-all duration-300 cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.06}s` }}
            >
              <div
                className={`w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-xl ${
                  cat.color === 'primary'
                    ? 'bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50'
                    : cat.color === 'accent'
                    ? 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50'
                    : 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-background-50'
                } transition-all duration-300`}
              >
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-foreground-950 font-heading font-semibold text-sm mb-1">
                {cat.name}
              </h3>
              <p className="text-foreground-400 text-xs">{cat.count} 条内容</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/remen-tuijian"
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-background-300 rounded-full text-foreground-600 text-sm font-medium hover:border-primary-400 hover:text-primary-600 transition-all duration-300 cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}